<template>
  <v-container>
    <v-layout>
      <v-flex class="mr-2">
        <v-menu
          ref="showDateMenu"
          v-model="showDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              persistent-hint
              prepend-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dates"
            no-title
            range
            @change="changeDateMenu"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex >
        <v-select
          :color="Theme.GREEN"
          :items="getWatsonsOrderType"
          item-text="text"
          item-value="key"
          v-model="watsonsOrderType"
        />
      </v-flex>
      <v-flex class="mr-2" v-if="watsonsOrderType === 'shippingStatus'">
        <v-select
            :color="Theme.GREEN"
            :items="getWatsonsShippingStatus"
            item-text="text"
            item-value="key"
            v-model="searchValue"
        />
      </v-flex>
      <v-flex class="mr-2" v-else>
        <v-text-field v-model="searchValue" label="搜尋"
                      :color="Theme.GREEN" placeholder="搜尋資料"></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn
          class="mr-2"
          :color="Theme.GREEN"
          dark
          @click.prevent="searchEvent"
          >搜尋</v-btn
        >
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
      <v-flex>
        <v-spacer></v-spacer>
        <v-btn
          style="float: right"
          class="mr-2"
          :color="Theme.PINK"
          dark
          @click.prevent="handle"
          >匯入訂單</v-btn
        >
        <input
          ref="uploader"
          class="d-none"
          type="file"
          @change="onFileChanged($event)"
          accept=".xlsx,.xls"
        />
      </v-flex>
      <v-flex>
        <v-btn
          class="mr-2"
          :color="Theme.YELLOW"
          dark
          @click.prevent="exportCSV"
          >匯出訂單</v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <table-view
          :items="list"
          :columnKeys="getColumnKeys"
          :pagination="pagination"
          :loading="loading"
          @changePage="changePage"
          @cellEvent="cellEvent"
        />
      </v-flex>
    </v-layout>

    <watsons-detail
      :title="editView.title"
      :visible="editView.visible"
      :item-detail="editView.item"
      :show-cancel="editView.showCancel"
      @cancelEvent="editView.cancelEvent"
      @confirmEvent="editView.confirmEvent"
    />
    <label-view
    :visible="labelView.visible"
    :title="labelView.title"
    :item="labelView.item"
    @cancelEvent="labelView.visible = false"
    @confirmEvent="labelView.visible = false"
    ></label-view>
  </v-container>
</template>

<script>
import TableView from "@/components/TableView";
import WatsonsDetail from "./WatsonsDetail";
import { mapGetters, mapActions } from "vuex";
import { read, utils, writeFile } from 'xlsx'
import common from "@/mixins/common";
import LabelView from "@/components/LabelView";

export default {
  name: "watsons",
  components: {
    TableView,
    WatsonsDetail,
    LabelView
  },
  mixins: [common],
  data() {
    return {
      searchValue:'',
      loading: false,
      pagination: {
        startDate: "2000-01-01",
        endDate: "2099-01-01",
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list: [],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: () => {},
        cancelEvent: () => {},
      },
      watsonsOrderType: "all",
      dates: [
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substring(0, 10),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substring(0, 10),
      ],
      showDateMenu: false,
      labelView:{
        visible:false,
        title:"列印",
        item:null
      }
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapGetters([]),
    getColumnKeys() {
      let columnKeys = [
        {
          value: "edit",
          text: "編輯",
          isEvent: true,
          color: this.Theme.GREEN,
          sortable: false,
        },
        { value: "orderId", text: "訂單編號", sortable: true },
        { value: "watsonsId", text: "屈臣氏編號", sortable: true },
        { value: "customName", text: "收件人姓名", sortable: false },
        { value: "orderDate", text: "訂單日期", sortable: false },
        { value: "watsonsStatus", text: "狀態", sortable: false , options: [
            { key: -1, text: '已退貨'},
            { key: 0, text: '待處理'},
            { key: 1, text: '已建立訂單'}
          ]},
        { value: "shopNo", text: "取貨店號", sortable: false },
        { value: "payType", text: "付款方式", sortable: true },
        { value: "shopName", text: "取貨門市名稱", sortable: false },
        { value: "phone", text: "電話", sortable: false },
        { value: "price", text: "總金額", sortable: false },
        { value: "shippingNumber", text: "出貨單號", sortable: false },
        { value: "shippingDate", text: "出貨日期", sortable: false },
        { value: "shippingStatus", text: "出貨狀態", sortable: false,  options: [
            { key: -1, text: '驗退'},
            { key: 0, text: '--'},
            { key: 1, text: '已到貨'},
            { key: 2, text: '已取貨'}
          ] },
        { value: "picked_at", text: "取貨日期", sortable: false },
        {
          value: "createOrder",
          text: "建立訂單",
          isEvent: true,
          color: this.Theme.GREEN,
          sortable: false,
        },
        {
          value: "refundsOrder",
          text: "退貨",
          isEvent: true,
          color: this.Theme.PINK,
          sortable: false,
        },
        {
          value: "printLabel",
          text: "列印",
          isEvent: true,
          color: this.Theme.PINK,
          sortable: false,
        },
        {
          value: "delete",
          text: "刪除",
          isEvent: true,
          color: this.Theme.YELLOW,
          sortable: false,
        },
      ];
      return columnKeys;
    },
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
  },
  methods: {
    ...mapActions([
      "saveMultiOrders",
      "watsonsList",
      "watsonsDelete",
      "watsonsCreate",
      "watsonsRefundsOrder",
    ]),
    changeDateMenu() {
      const dateArray = Object.keys(this.dates);
      const dateCount = dateArray.length;
      this.showDateMenu = dateCount !== 2;
    },
    async loadData() {
      try {
        this.loading = true;
        let searchQuery = [];
        if (this.watsonsOrderType && this.watsonsOrderType !== "all") {
          let query = {
            key: this.watsonsOrderType,
            value: this.searchValue,
          };
          searchQuery.push(query);
        }
        this.pagination.startDate = this.dates[0];
        this.pagination.endDate = this.dates[1];
        const res = await this.watsonsList({
          startDate: this.pagination.startDate,
          endDate: this.pagination.endDate,
          pageIndex: this.pagination.page,
          limit: this.pagination.itemsPerPage,
          searchQuery: searchQuery,
          admin: "1",
        });

        if (res.data.code === 0) {
          this.list = res.data.body.list;
          // for (let order of this.list){
          //   order.shippingStatus = this.getShippingStatus(order);
          // }
          this.pagination.totalItems = res.data.body.header.totalCount;
        }
      } finally {
        this.loading = false;
      }
    },
    // getShippingStatus(order){
    //   if (`${order.returned_at}` !== '0000-00-00 00:00:00' && order.returned_at){
    //     return '驗退'
    //   }
    //   if (`${order.picked_at}` !== '0000-00-00 00:00:00' && order.picked_at){
    //     return '已取貨'
    //   }
    //   if (`${order.received_at}` !== '0000-00-00 00:00:00' && order.received_at){
    //     return '已到貨'
    //   }
    //   return '--';
    // },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page) {
      this.pagination.page = page.page;
      if (page.itemsPerPage === -1) {
        this.pagination.itemsPerPage = 1000;
      } else {
        this.pagination.itemsPerPage = page.itemsPerPage;
      }
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell) {
      if (cell.key === "delete") {
        this.showAlert({
          title: "提示",
          content: "是否確定要刪除此訂單？",
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          },
        });
      } else if (cell.key === "createOrder") {
        this.showAlert({
          title: "提示",
          content: "是否確定要建立此訂單？",
          showInput: true,
          confirmEvent: async (data) => {
            this.hideAlert();
            await this.watsonsCreateEvent(cell.item, data);
          },
        });
      } else if (cell.key === "refundsOrder") {
        this.showAlert({
          title: "提示",
          content: "是否確定退貨此訂單？",
          confirmEvent: async () => {
            this.hideAlert();
            await this.watsonsRefundsOrderEvent(cell.item);
          },
        });
      } else if (cell.key === "printLabel") {
        // this.labelView.visible = true;
        // this.labelView.item = cell.item
        // this.$router.push({ path: '/printView', query: cell.item });
        const routeData = this.$router.resolve({ path: '/printView', query: cell.item});
        window.open(routeData.href, '_blank');

      } else {
        if (!cell.item.imageList) {
          cell.item.imageList = [];
        }
        if (!cell.item.linkList) {
          cell.item.linkList = [];
        }

        this.editView.title = cell.key === "add" ? "新增訂單" : "修改訂單";
        this.editView.item = cell.item;
        this.editView.visible = true;
        this.editView.cancelEvent = () => {
          this.editView.visible = false;
        };
        this.editView.confirmEvent = () => {
          this.editView.visible = false;
          this.loadData();
        };
      }
    },
    searchEvent() {
      this.loadData();
    },
    reset() {
      this.dates = [
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substring(0, 10),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substring(0, 10),
      ];
      this.searchValue = '';
      this.watsonsOrderType = 'all';
      this.loadData();
    },
    async deleteEvent(item) {
      const res = await this.watsonsDelete({
        orderId: item.orderId,
      });
      if (res.data.code === 0) {
        this.reset();
      }
    },
    async watsonsCreateEvent(item, shippingInfo) {
      const data = {
        orderId: item.orderId,
        shippingDate: shippingInfo.shippingDate,
        shippingNumber: shippingInfo.shippingNumber,
      };
      const res = await this.watsonsCreate(data);
      if (res.data.code === 0) {
        this.reset();
      }
    },
    async watsonsRefundsOrderEvent(item) {
      try {
        const data = {
          orderId: item.orderId,
        };
        const res = await this.watsonsRefundsOrder(data);
        const result = res.data;
        console.log(`watsonsRefundsOrder result === `, JSON.stringify(result));
        if (result && result.code === 0) {
          this.reset();
        } else {
          this.showAlert({
            title: "提示",
            content: result.data.message ? result.data.message: `錯誤`,
            showCancel: false,
            confirmEvent: async () => {
              this.hideAlert();
            },
          });
        }
      } catch (e) {
        console.log(`watsonsRefundsOrder error === `, e);
        this.showAlert({
          title: "提示",
          content: e.data.message ? e.data.message: `錯誤`,
          showCancel: false,
          confirmEvent: async () => {
            this.hideAlert();
          },
        });
      }
    },
    handle() {
      this.showAlert({
        title: "提示",
        content: "是否建立訂單？",
        confirmEvent: async () => {
          this.hideAlert();
          this.$refs.uploader.click();
        },
      });
    },
    exportCSV() {
      this.showAlert({
        title: "匯出訂單",
        content: "匯出訂單時間區間",
        showDate: true,
        confirmEvent: async (item) => {
          await this.exportCsvFile(item[0], item[1]);
          this.hideAlert();
        },
      });
    },
    async exportCsvFile(startDate, endDate) {
      try {
        this.loading = true;
        const res = await this.watsonsList({
          startDate: startDate,
          endDate: endDate,
          pageIndex: 1,
          limit: 10000,
          searxhQuery: [],
          admin: "1",
        });

        if (res.data.code === 0) {
          const dataList = res.data.body.list;
          // 取 data 的第一個 Object 的 key 當表頭
          let arrayTitle = Object.keys(dataList[0]).filter(
            item => item !== "createdDate" && item !== "received_at"
                && item !== "returned_at" && item !== "error_message");

          let arrayData = [];
          arrayData.push([
            "訂單編號",
            "屈臣氏編號",
            "收件人姓名",
            "付款方式",
            "訂單日期",
            "取貨店號",
            "取貨門市名稱",
            "電話",
            "總金額",
            "出貨日期",
            "出貨單號",
            "訂單狀態",
            "到貨時間",
            "出貨狀態",
          ]);
          // 取出每一個 Object 裡的 value，push 進新的 Array 裡
          dataList.forEach((d) => {
            let items = [];
            arrayTitle.forEach((title) => {
              let item = d[title] || "無";
              if (title.indexOf("date") >= 0) item.replace("-", "/");
              if (title.indexOf("watsonsStatus") >= 0) {
                const info = this.getWatsonsStatus.filter(x => x.key === d[title]);
                item = info[0].text
              }
              if (title.indexOf("shippingStatus") >= 0) {
                console.log(`shippingStatus ${d[title]}`)
                const info = this.getWatsonsShippingStatus.find(x => x.key === `${d[title]}`);
                console.log(`shippingStatus info = ${JSON.stringify(info)}`);
                if (info){
                  item = info.text;
                }
              }
              //console.log(`title ${title} = ${title.indexOf('picked_at')} | ${d['picked_at']}`)
              if (title.indexOf('picked_at') >= 0) {

                if (d['received_at'] !== '0000-00-00 00:00:00'){
                  item = d['received_at'];
                }

                if (d['returned_at'] !== '0000-00-00 00:00:00'){
                  item = d['returned_at'];
                }

                if (d['picked_at'] !== '0000-00-00 00:00:00'){
                  item = d['picked_at'];
                }
              }
              items.push(`${item}`);
            });
            arrayData.push(items);
          });
          const fileName = "下載資料_" + new Date().getTime() + ".xlsx";
          const myWorkSheet = utils.aoa_to_sheet(arrayData);
          const myWorkBook = utils.book_new();
          utils.book_append_sheet(myWorkBook, myWorkSheet, "myWorkSheet");
          writeFile(myWorkBook, fileName);
        }
      } finally {
        this.loading = false;
      }
    },
    async onFileChanged(e) {
      const files = e.target.files;
      const file = files[0];

      var reader = new FileReader();
      const self = this;
      reader.onload = async (ev) => {

        const data = ev.target.result;
        const workbook = read(data, {
          type: 'binary'
        })
        const wsname = workbook.SheetNames[0];
        const ws = utils.sheet_to_json(workbook.Sheets[wsname], {raw:false});

        if(ws && ws.length) {
          let dataArray = [];
          ws.forEach((element) => {
            const values = Object.values(element);
            console.log(`valuses ${JSON.stringify(values)}`)
            const info = {
              orderId: values[0],
              orderDate: values[1], //yyyy-mm-dd hh:mm:ss
              payType: values[2],
              customName: values[3],
              phone: values[4],
              shopName: values[5],
              shopNo: values[6],
              price: values[7],
            };
            dataArray.push(info);
          });
          const info = {
            list:dataArray
          }
          const res = await this.saveMultiOrders(info);

          if (res.data.code === 0) {
            await self.loadData();
          }
        }
      };
      reader.readAsBinaryString(file);
    },
  },
};
</script>

<style scoped></style>
